import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const DRAWER_WIDTH = 270;
const ANIMATION_DURATION = 500;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      /* overflowX: 'hidden', */
      width: '100%',
      flexGrow: 1,
      padding: theme.spacing(3),
      marginBottom: theme.spacing(7),
      [theme.breakpoints.up('xl') + 1]: {
        '& > div:nth-of-type(2)': {
          maxWidth: 1400,
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },
    small: {
      width: `calc(100% - ${DRAWER_WIDTH}px)`,
      marginLeft: DRAWER_WIDTH,
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),

      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
        marginLeft: 0,
      },
    },
    large: {
      width: `calc(100% - ${73}px)`,
      marginLeft: 73,
      transition: theme.transitions.create('all', {
        easing: theme.transitions.easing.sharp,
        duration: ANIMATION_DURATION,
      }),
      [theme.breakpoints.between('xs', 'sm')]: {
        width: '100%',
        marginLeft: 0,
      },
    },
  }),
);

export default useStyles;
